/**
 * Header component for the Create Chat page
 */

import { Button } from '@heroui/react';
import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export const CreateChatHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/chats');
  };

  return (
    <div className="flex items-center gap-4">
      <Button
        variant="light"
        isIconOnly
        onPress={handleBackClick}
        aria-label="Back to chats list"
        className="text-default-600 hover:text-foreground"
      >
        <FiArrowLeft size={20} />
      </Button>
      <div>
        <h1 className="title-large">Create Chat</h1>
        <p className="text-default-600 mt-1">
          Set up a new chat between a buyer and distributor
        </p>
      </div>
    </div>
  );
};
